import { EDrivingMarketSectionType } from "@domains/features/Markets/Equity/entities/iDrivingMarket";
import React from "react";
import ReportValue from "./../../../generic/commonTableVal";
import { circuitparams, performersparams, pricebuzzerparams, volumeBuzzerParams, weeklistparams, } from "./constant";
export const StreamReportValue = (key, percentage = false, isRoundBracket = false, showZero = true) => {
    return (React.createElement(ReportValue, { val: key, stream: true, onlyval: false, percentage: percentage, notRoundBracket: isRoundBracket, showZero: showZero }));
};
export const NonStreamReportValue = (key) => {
    return React.createElement(ReportValue, { val: key, stream: false, onlyval: false });
};
export const viewAll = {
    allTimeHigh: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "All Time" /* CommonMKtContants.AllTime */),
            "\u00A0",
            "High" /* CommonMKtContants.High */)),
        SectionType: "High" /* CommonMKtContants.High */,
        isTab: true,
        OptionTDList: weeklistparams,
        sectionName: EDrivingMarketSectionType.HIGH,
        tableClass: "alltime-table",
    },
    allTimeLow: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "All Time" /* CommonMKtContants.AllTime */),
            "\u00A0",
            "Low" /* CommonMKtContants.Low */)),
        SectionType: "Low" /* CommonMKtContants.Low */,
        isTab: true,
        OptionTDList: weeklistparams,
        sectionName: EDrivingMarketSectionType.LOW,
        tableClass: "alltime-table",
    },
    upperCircuit: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Upper" /* CommonMKtContants.Upper */),
            "\u00A0",
            "Circuit" /* CommonMKtContants.Circuit */)),
        SectionType: "Upper" /* CommonMKtContants.Upper */,
        isTab: false,
        OptionTDList: circuitparams,
        sectionName: EDrivingMarketSectionType.UPPER,
    },
    lowerCircuit: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Lower" /* CommonMKtContants.Lower */),
            "\u00A0",
            "Circuit" /* CommonMKtContants.Circuit */)),
        SectionType: "Lower" /* CommonMKtContants.Lower */,
        isTab: false,
        OptionTDList: circuitparams,
        sectionName: EDrivingMarketSectionType.LOWER,
    },
    TopGainer: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Top" /* CommonMKtContants.Top */),
            "\u00A0",
            "Gainers" /* CommonMKtContants.Gainers */)),
        SectionType: "Gainers" /* CommonMKtContants.Gainers */,
        isTab: true,
        OptionTDList: weeklistparams,
        sectionName: EDrivingMarketSectionType.GAIN,
        parentClass: "top-table",
    },
    TopLooser: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Top" /* CommonMKtContants.Top */),
            "\u00A0",
            "Losers" /* CommonMKtContants.Losers */)),
        SectionType: "Losers" /* CommonMKtContants.Losers */,
        isTab: true,
        OptionTDList: weeklistparams,
        sectionName: EDrivingMarketSectionType.LOSS,
        parentClass: "top-table",
    },
    IndexPullers: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Index" /* CommonMKtContants.Index */),
            "\u00A0",
            "Pullers" /* CommonMKtContants.Pullers */)),
        SectionType: "Pullers" /* CommonMKtContants.Pullers */,
        sectionName: EDrivingMarketSectionType.PULLERS,
        isTab: true,
        OptionTDList: weeklistparams,
        tableClass: "index-table",
    },
    IndexDraggers: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Index" /* CommonMKtContants.Index */),
            "\u00A0",
            "Draggers" /* CommonMKtContants.Draggers */)),
        SectionType: "Draggers" /* CommonMKtContants.Draggers */,
        sectionName: EDrivingMarketSectionType.DRAGGERS,
        isTab: true,
        OptionTDList: weeklistparams,
        tableClass: "index-table",
    },
    WeekHigh: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "52 Week" /* CommonMKtContants.FiftyTwoWeek */),
            "\u00A0",
            "High" /* CommonMKtContants.High */)),
        SectionType: "High" /* CommonMKtContants.High */,
        isTab: true,
        sectionName: EDrivingMarketSectionType.WEEK_HIGH,
        OptionTDList: weeklistparams,
        tableClass: "week-high-low",
    },
    WeekLow: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "52 Week" /* CommonMKtContants.FiftyTwoWeek */),
            "\u00A0",
            "Low" /* CommonMKtContants.Low */)),
        SectionType: "Low" /* CommonMKtContants.Low */,
        isTab: true,
        sectionName: EDrivingMarketSectionType.WEEK_LOW,
        OptionTDList: weeklistparams,
        tableClass: "week-high-low",
    },
    OutPerformers: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Out" /* CommonMKtContants.Out */),
            "\u00A0",
            "Performers" /* CommonMKtContants.Performers */)),
        SectionType: "Out" /* CommonMKtContants.Out */,
        isTab: true,
        OptionTDList: performersparams,
        sectionName: EDrivingMarketSectionType.OUT,
        tableClass: "performer-table",
    },
    UnderPerformers: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Under" /* CommonMKtContants.Under */),
            "\u00A0",
            "Performers" /* CommonMKtContants.Performers */)),
        SectionType: "Under" /* CommonMKtContants.Under */,
        isTab: true,
        OptionTDList: performersparams,
        sectionName: EDrivingMarketSectionType.UNDER,
        tableClass: "performer-table",
    },
    Pricebuzzer: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Price" /* CommonMKtContants.Price */),
            "\u00A0",
            "Buzzers" /* CommonMKtContants.Buzzers */)),
        SectionType: "Price" /* CommonMKtContants.Price */,
        isTab: true,
        OptionTDList: pricebuzzerparams,
        sectionName: EDrivingMarketSectionType.PRICE,
        tableClass: "price-buzzers-table",
    },
    VolumeBuzzer: {
        title: (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Volume" /* CommonMKtContants.Volume */),
            "\u00A0",
            "Buzzers" /* CommonMKtContants.Buzzers */)),
        SectionType: "Volume" /* CommonMKtContants.Volume */,
        isTab: true,
        sectionName: EDrivingMarketSectionType.VOLUME,
        OptionTDList: volumeBuzzerParams,
        tableClass: "volume-buzzers-table",
    },
};
